import { ArrowRight } from "lucide-react";

export default function Hero() {
    const scrollTo = (id) => {
        const el = document.querySelector(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <section
            data-testid="hero-section"
            className="relative pt-40 pb-24 md:pt-52 md:pb-32 overflow-hidden bg-brand-paper"
        >
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute top-20 -left-32 w-[36rem] h-[36rem] rounded-full bg-brand-gold/5 blur-3xl" />
                <div className="absolute bottom-0 right-0 w-[28rem] h-[28rem] rounded-full bg-brand-gold/10 blur-3xl" />
            </div>

            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
                    <div className="lg:col-span-7 fade-in-up">
                        <div className="flex items-center gap-3 mb-8">
                            <span className="w-10 h-px bg-brand-gold" />
                            <span className="text-[10px] tracking-[0.4em] uppercase text-brand-gold-deep">
                                Premium Medical Courier
                            </span>
                        </div>

                        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95] text-brand-black tracking-tight">
                            Delivered
                            <br />
                            with{" "}
                            <span className="italic text-brand-gold-deep">trust.</span>
                            <br />
                            Driven by{" "}
                            <span className="italic">purpose.</span>
                        </h1>

                        <p className="mt-10 text-lg md:text-xl text-brand-black/70 font-light max-w-xl leading-relaxed">
                            SheFleet Transportation moves what matters most — lab specimens,
                            pharmaceuticals, and medical supplies — across Missouri and Southern
                            Illinois with the care your patients deserve.
                        </p>

                        <div className="mt-12 flex flex-col sm:flex-row gap-4">
                            <button
                                data-testid="hero-cta-schedule"
                                onClick={() => scrollTo("#booking")}
                                className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-brand-black text-white text-xs tracking-[0.25em] uppercase hover:bg-brand-gold-deep transition-all duration-300"
                            >
                                Schedule a Pickup
                                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                            </button>
                            <button
                                data-testid="hero-cta-services"
                                onClick={() => scrollTo("#services")}
                                className="inline-flex items-center justify-center gap-3 px-8 py-4 border border-brand-black text-brand-black text-xs tracking-[0.25em] uppercase hover:bg-brand-black hover:text-white transition-all duration-300"
                            >
                                Our Services
                            </button>
                        </div>

                        <div className="mt-16 grid grid-cols-3 gap-6 max-w-lg">
                            <div>
                                <div className="font-serif text-3xl md:text-4xl text-brand-black">15</div>
                                <div className="text-[10px] tracking-[0.2em] uppercase text-brand-black/60 mt-1">
                                    Counties Served
                                </div>
                            </div>
                            <div>
                                <div className="font-serif text-3xl md:text-4xl text-brand-black">24<span className="text-brand-gold">/</span>7</div>
                                <div className="text-[10px] tracking-[0.2em] uppercase text-brand-black/60 mt-1">
                                    Dispatch Ready
                                </div>
                            </div>
                            <div>
                                <div className="font-serif text-3xl md:text-4xl text-brand-black">STAT</div>
                                <div className="text-[10px] tracking-[0.2em] uppercase text-brand-black/60 mt-1">
                                    Rush Available
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-5 relative fade-in-up delay-200">
                        <div className="relative">
                            <div className="absolute -inset-4 border border-brand-gold/40" />
                            <div className="relative w-full h-[480px] md:h-[560px] overflow-hidden">
                                <picture>
                                    <source srcSet="/hero-van.webp" type="image/webp" />
                                    <img
                                        src="/hero-van.jpg"
                                        alt="SheFleet Sprinter cargo van at medical center deliveries"
                                        width="900"
                                        height="1124"
                                        fetchPriority="high"
                                        loading="eager"
                                        decoding="async"
                                        className="w-full h-full object-cover"
                                    />
                                </picture>
                            </div>
                            <div className="absolute -bottom-8 -left-8 bg-brand-black text-white p-6 md:p-8 max-w-xs hidden md:block z-10">
                                <div className="text-[10px] tracking-[0.3em] uppercase text-brand-gold mb-3">
                                    Women-Owned
                                </div>
                                <div className="font-serif text-2xl leading-snug">
                                    Built by Shameeka &amp; Tiffani.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
